import {Model} from "vue-mc";

export class Listing extends Model
{
    static STATUS = {
        ACTIVE: "active",
        DORMANT: "dormant",
    }

    static TYPES = {
        GENERAL: "general",
        OBJECTION_LISTING: "objection_listing",
    }

    defaults() {
        return {
            id: '',
            name: null,
            description: '',
            type: Listing.TYPES.GENERAL,
            status: Listing.STATUS.ACTIVE,
            subscribers: [],
            externalProviderId: null,
        }
    }
}
